import React from 'react';

const AppModeContext = React.createContext({});

export default AppModeContext;
